module.exports = __webpack_public_path__ + "static/Framleidslageimherb-47e583fab02b736e97fbf239c9b68114.png";